import { render, staticRenderFns } from "./AttributeDefinitionView.vue?vue&type=template&id=549ea0df&scoped=true&lang=pug&"
import script from "./AttributeDefinitionView.vue?vue&type=script&lang=ts&"
export * from "./AttributeDefinitionView.vue?vue&type=script&lang=ts&"
import style0 from "./AttributeDefinitionView.vue?vue&type=style&index=0&id=549ea0df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549ea0df",
  null
  
)

export default component.exports